import { useTranslation } from "react-i18next";

interface RegisterSubjectNameButtonProps {
  onBtnClick: () => void;
  disabled:boolean;
}

export const RegisterSubjectNameButton: React.FC<
  RegisterSubjectNameButtonProps
> = ({ onBtnClick,disabled}) => {

        //言語切替用
    const { t } = useTranslation();
    return (
    <>
        <div className="flex justify-center">
            <button
                disabled={disabled}
                className={`
                    ${!disabled? "border-main-red bg-white": "border-gray-500 bg-gray-300 text-gray-500"} 
                    rounded-full border-2 py-1 px-6 w-40 overflow-hidden whitespace-nowrap
                `}
                onClick={onBtnClick}>
                
                {/* 保存 */}
                <p className="font-bold text-[20px]">{t("案件名登録画面.登録")}</p>
                
            </button>
        </div>
    </>);

}